import React, { useState, useEffect } from "react";
import { Container, Wrapper } from "pages/Admin/Validations/ValidationsStyled";
import { CircleBtn } from "assets/css/globle";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useTranslation } from "react-i18next";
import { useHookstate } from "@hookstate/core";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { PopUpContainer } from "assets/css/globle";
import { SITEID_GLOBAL_STATE, CHECKBOX_LOADER } from "globalStore/globalStore";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { Loader } from "commonComponents/Loader/Loader";
import { Typography } from "@mui/material";
import { API_STATUSES } from "redux/_helpers/statuses";
import {
  getValidatePinDataStatusAction as getValidatePinDataStatus,
  getValidateZoneDataStatusAction as getValidateZoneDataStatus,
} from "redux/reduxToolkitServices/_commonReducers/commonReducers";

export const Validations = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    padding: "10px",
    transform: "translate(-50%, -50%)",
    maxWidth: "1000px",
    width: "100%",
    bgcolor: "background.paper",
    borderRadius: "5px",
    maxHeight: "calc(100vh - 200px)",
    overflow: "auto",
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "calc(100% -  40px)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [openPin, setOpenPin] = useState(false);
  const [validationErrorModal, setValidationErrorModal] = useState(false);
  const [fail2, setFail2] = useState(false);
  const [openZone, setOpenZone] = useState(false);
  const { pinLoader, zoneLoader } = useHookstate(CHECKBOX_LOADER);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const {
    getValidateZoneDataStateAction,
    getValidatePinDataStateAction,
    getValidatePinDataStatusAction,
    getValidateZoneDataStatusAction,
  } = useSelector((state) => state.commonReducers) || [];
  //########################### function that holds or generates HTML content ################################//
  function createMarkupForPins() {
    return { __html: getValidatePinDataStateAction };
  }
  function createMarkupForActionZone() {
    return { __html: getValidateZoneDataStateAction };
  }
  //########################### function that holds or generates HTML content ################################//
  const handleClosePin = () => {
    setOpenPin(false);
  };

  const handleCloseZone = () => {
    setOpenZone(false);
  };

  const handleCloseFail2 = () => {
    setFail2(false);
    dispatch(getValidateZoneDataStatus(API_STATUSES.IDLE));
  };

  useEffect(() => {
    if (getValidateZoneDataStatusAction === API_STATUSES.ERROR) {
      zoneLoader.set(false);
      setFail2(true);
    } else if (getValidateZoneDataStatusAction === API_STATUSES.SUCCESS) {
      zoneLoader.set(false);
      setOpenZone(true);
    } else if (getValidateZoneDataStatusAction === API_STATUSES.REQUEST) {
      zoneLoader.set(true);
    } else {
      zoneLoader.set(false);
      setOpenZone(false);
    }
  }, [getValidateZoneDataStatusAction]);

  useEffect(() => {
    if (getValidatePinDataStatusAction === API_STATUSES.ERROR) {
      pinLoader.set(false);
      setValidationErrorModal(true);
    } else if (getValidatePinDataStatusAction === API_STATUSES.SUCCESS) {
      pinLoader.set(false);
      setOpenPin(true);
    } else if (getValidatePinDataStatusAction === API_STATUSES.REQUEST) {
      pinLoader.set(true);
    } else {
      pinLoader.set(false);
      setOpenPin(false);
    }
  }, [getValidatePinDataStatusAction]);

  const handlePinValidation = () => {
    dispatch(COMMON_SERVICES.getValidatePinTabServices(siteId.get()));
  };

  const handleActionZoneValidation = () => {
    dispatch(COMMON_SERVICES.getValidateZoneTabServices(siteId.get()));
  };
  //######################select the contents of an HTML element##############################//
  function selectElementContents(el) {
    let range = document.createRange();
    range.selectNodeContents(el);
    //get the current selection object
    let sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    el.focus();
  }

  function selectAllText() {
    let el = document.getElementById("theValidationData");
    selectElementContents(el);
  }
  //######################select the contents of an HTML element##############################//
  return (
    <>
      <Container>
        <Wrapper>
          <div className="action-wrapper">
            <CircleBtn
              className={openPin ? "active" : ""}
              onClick={handlePinValidation}
            >
              {t("Validate_Pin_Placements")}
            </CircleBtn>
            <CircleBtn
              className={openZone ? "active" : ""}
              onClick={handleActionZoneValidation}
            >
              {t("Validate_action_zones")}
            </CircleBtn>
          </div>
        </Wrapper>
      </Container>
      {pinLoader.get() && (
        <CenteredLoader className="innerSectionLoader">
          <Loader />
        </CenteredLoader>
      )}

      <Modal
        open={validationErrorModal}
        onClose={() => {
          setValidationErrorModal(false);
          dispatch(getValidatePinDataStatus(API_STATUSES.IDLE));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <PopUpContainer>
            <h2>{t("Pin_Placement_Validation")}</h2>
            <p>{t("Call_to_Validate_Pin_Placement_Data_Failed")} </p>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button
                onClick={() => {
                  setValidationErrorModal(false);
                  dispatch(getValidatePinDataStatus(API_STATUSES.IDLE));
                }}
                className="primary"
              >
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>

      <Modal
        open={openZone}
        onClose={handleCloseZone}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2 style={{ marginBottom: 10 }}>{t("Validation_Data")}</h2>
            <div
              id="theValidationData"
              dangerouslySetInnerHTML={createMarkupForActionZone()}
            />
            <div className="action-btn" style={{ marginTop: 10 }}>
              <button onClick={() => selectAllText()} className="primary">
                {t("Select_all_text")}
              </button>
              <button onClick={handleCloseZone}>{t("Close")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      {zoneLoader.get() && (
        <CenteredLoader className="innerSectionLoader">
          <Loader />
        </CenteredLoader>
      )}
      <Modal
        open={openPin}
        onClose={handleClosePin}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2 style={{ marginBottom: 10 }}>{t("Validation_Data")}</h2>
            <div
              id="theValidationData"
              dangerouslySetInnerHTML={createMarkupForPins()}
            />
            ;
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button onClick={() => selectAllText()} className="primary">
                {t("Select_all_text")}
              </button>
              <button onClick={handleClosePin}>{t("Close")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>

      <Modal
        open={fail2}
        onClose={handleCloseFail2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <PopUpContainer>
            <h2 style={{ marginBottom: 10 }}>
              Action Zones Placement Validation
            </h2>
            <Typography>Call to Validate Actions Zones Data Failed</Typography>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button onClick={handleCloseFail2} className="primary">
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </>
  );
};

export default Validations;
